import { createApp } from 'vue';
import { createPinia } from 'pinia';
import jQuery from 'jquery';
import { router } from '~/src/router';
import App from '../src/App.vue';
import PrimeVue from "primevue/config";
import Lara from '@primeuix/themes/lara';

// Setup FA icons
import '../src/icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// End Setup FA icons

// Set up bootstrap
import 'popper.js';
import 'bootstrap';
import VueTheMask from 'vue-the-mask'
import { announceLogin, followLoginFromOtherTabs } from '../src/services/session/loginSync';
import { takeReturnPage } from '../src/services/session/returnPage';
import { refreshCsrfTokenOnSubmit } from '../src/services/session/csrfRefresh';

window.$ = jQuery;

const rootElementId = 'buckeye-portal-app-root';
const element = document.getElementById(rootElementId);

if (element) {
  const appStore = createPinia()
  const app = createApp(App);
  app.component('font-awesome-icon', FontAwesomeIcon);
  app.component('buckeye-portal-app', App);
  app.use(router);
  app.use(appStore);
  app.use(PrimeVue, {
    theme: {
      preset: Lara,
      options: {
        darkModeSelector: false
      }
    },
    zIndex: {
      modal: 1100,        //dialog, sidebar
      overlay: 9999,      //dropdown, overlaypanel
      menu: 1000,         //overlay menus
      tooltip: 1100       //tooltip
    }
  });
  app.use(VueTheMask);

  // Back to the page this tab was on before the session ended. Replaces the router's initial navigation to the
  // current URL, so that page is never shown.
  const returnPage = takeReturnPage();
  if (returnPage) router.replace(returnPage);

  app.mount(`#${rootElementId}`);

  // The layout only renders the app root for signed in users, take any login pages open in other tabs into the app
  announceLogin();
} else {
  // Signed out page (login, forgot password), follow a login from another tab into the app
  followLoginFromOtherTabs();
  refreshCsrfTokenOnSubmit();
}
